module.exports = __webpack_public_path__ + "img/logoinit.90e86614.png";